// extracted by mini-css-extract-plugin
export default {"speakerWrapper":"WaitingRoomSpeaker-module-d2660c37f78f4c05e8ba"};